import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProviderportalService } from '../providerportal.service';
import { ClaimnavigationService } from './claimnavigation.service';
import { DisputeDialogComponent } from './dispute-dialog/dispute-dialog.component';
import { Router } from '@angular/router';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'app-claimsummary',
    templateUrl: './claimsummary.component.html',
    styleUrls: ['./claimsummary.component.scss'],
    standalone: false
})


export class ClaimsummaryComponent implements OnInit,OnDestroy {
  providerClaimData = [];
  copyOfProviderClaimData = [];
  originalProviderClaimData = [];
  loading = false;
  data = [];
  provider = [];
  details = [];
  p: number = 1;
  searchInput: string;
  copyOfList: any[] = [];
  name: any;
  list: any[] = [];
  searchTerm: any;
  public isNUmber = false;
  public noRecords = false;
  rangeDates: Date[];
  minDate: Date;
  maxDate: Date;
  startMinDate: Date;
  startMaxDate: Date;
  endMinDate: Date;
  endMaxDate: Date;
  fromDate: Date;
  toDate: Date;
  durtionRadioBtn: boolean;
  disableToDate: boolean;
  disableClaimsBtn: boolean;
  showClaimsResults: boolean;
  showClaimsResultsForLast30Days: boolean;
  fromDateValue: any;
  endDateValue: any;
  fromDateWithFormat: any;
  toDateWithFormat: any;
  showDateSelection: boolean;
  dateRange: any;
  resultHeading: any;
  state: any;
  
  // Dispute related properties
  selectedClaimId: string = '';
  selectedClaimData: any = null;
  siteData: any;
  disputeTypes:any;
  private disputeDialogRef: MatDialogRef<DisputeDialogComponent> | null = null;
  handleResults(searchObj: any) {
      this.data = searchObj;
  }
  constructor(private providerPortalService: ProviderportalService,
    private claimnavigationService: ClaimnavigationService,
    private router: Router,
    private dialog: MatDialog) {}

  ngOnInit() {
  
    
    this.disableClaimsBtn = true;
    this.disableToDate = true;
    this.showClaimsResults = false;
    this.showClaimsResultsForLast30Days = true;
    this.showDateSelection = false;
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let date = today.getDate();
    this.startMinDate = new Date();
    this.startMinDate.setMonth(today.getMonth());
    this.startMinDate.setFullYear(today.getFullYear()-100);
    this.startMaxDate = new Date();
    if(this.claimnavigationService.markedFlag === false){
    this.durtionRadioBtn = true;
    this.getClaimTableData();
    
    } else{
      this.state = this.claimnavigationService.renderState().subscribe((element:any )=> {
        this.claimnavigationService.markedFlag= false;
        if(element[0].data.stateData )
        {
          let savedData = element[0].data.stateData ;
         this.originalProviderClaimData =savedData.savedoriginalProviderClaimData ;
          this.copyOfProviderClaimData = savedData.savedcopyOfProviderClaimData;
           this.providerClaimData = savedData.savedproviderClaimData;
          
        }
        let filterdData =  element[0].data.filters;
        if(filterdData){
          this.fromDateWithFormat = filterdData.fromDatetoSave;
          this.toDateWithFormat = filterdData.toDatetoSave;
          this.showClaimsResults = filterdData.showClaimsResultstosave;
          this.showClaimsResultsForLast30Days = filterdData.showClaimsResultsForLast30DaystoSave;
          this.endMaxDate = filterdData.endMaxDatetosave;
          this.endMinDate = filterdData.endMinDatetoSave;
          this.isNUmber = filterdData.isNUmbertoSave;
          // this.durtionRadioBtn = filterdData.durtionRadioBtntosave;
          // this.dateRange = filterdData.dateRangetoSave;
          this.showDateSelection = filterdData.showDateSelectiontosave;
          this.searchTerm = filterdData.searchTermtoSave;
          if(filterdData.showClaimsResultstosave === true){
            this.durtionRadioBtn = false;
          this.dateRange = false;
          }
          if(filterdData.showClaimsResultsForLast30DaystoSave === true){
            this.durtionRadioBtn = true;
            this.dateRange = true;
          }
        }
      });
    }
    
    }
getproviderDisputeReasonType(){
  this.providerPortalService.getproviderDisputeReasonType().subscribe((data:any)=>{
    this.disputeTypes = data
    if(data.length > 0){
      
    }
  })
}
  onFromSelect(event) {
    this.toDate = undefined;
    let selectedMonth = this.fromDate.getMonth();
    this.disableToDate = false;
    this.endMinDate = new Date();
    this.endMaxDate = new Date();
   
    if(selectedMonth==11){
      let nextMonth = 0; 
      this.endMinDate.setDate(this.fromDate.getDate());
      this.endMinDate.setMonth(this.fromDate.getMonth());
      this.endMinDate.setFullYear(this.fromDate.getFullYear());
      this.endMaxDate.setDate(this.fromDate.getDate());
      this.endMaxDate.setMonth(nextMonth);
      this.endMaxDate.setFullYear(this.fromDate.getFullYear()+1);
    }
    else {
      this.endMinDate.setDate(this.fromDate.getDate());
      this.endMinDate.setMonth(this.fromDate.getMonth());
      this.endMinDate.setFullYear(this.fromDate.getFullYear());
      this.endMaxDate.setDate(this.fromDate.getDate());
      this.endMaxDate.setMonth(this.fromDate.getMonth()+1);
      this.endMaxDate.setFullYear(this.fromDate.getFullYear());
      
    }
  }
  
  onToSelect(event) {
    this.disableClaimsBtn = false;
  }

  searchClaims() {
    this.getClaimTableData();
  }

  handleChange(evt) {
    var target = evt.target;
    this.fromDate = undefined;
    this.toDate = undefined;
    if (target.checked) {
      this.showDateSelection = true;
      this.showClaimsResultsForLast30Days = false;
      this.showClaimsResults = true;
    } else {
      this.showDateSelection = false;
    }
  }

  hideDateSelection(evt) {
    var target = evt.target;
    if (target.checked) {
      this.fromDate = undefined;
      this.toDate = undefined;
      this.getClaimTableData();
      this.showClaimsResults = false;
      this.showClaimsResultsForLast30Days = true;
      this.showDateSelection = false;
      this.fromDateWithFormat = undefined;
      this.toDateWithFormat = undefined;
    }
  }


  getClaimTableData(): void {
    this.loading = true;
    this.searchTerm = undefined;
    let detailsObject = {};
    let finalProviderArray: any[] = [];
    var list: any[] = [];
    var copyOfList: any[] = [];
    let duplicates: any[] = [];
    this.list = [];
    this.copyOfList = [];
    this.providerClaimData = [];
    try {
      this.providerPortalService.getProviderBasicDetails()
        .subscribe((data) => {
          const providerDetails = data;
          if (providerDetails && providerDetails.length > 0) {
            this.siteData = providerDetails;
            providerDetails.map((siteUser: any) => {
              if (siteUser && siteUser.providers && siteUser.providers.length > 0) {
                siteUser.providers.map((element: any) => {
                  if (!duplicates.includes(element.npi)) {
                    duplicates.push(element.npi);
                    if (this.fromDate && this.toDate) {
                      let fromDateMonth = ("0" + (this.fromDate.getMonth() + 1)).slice(-2);
                      let fromDateDate = ("0" + this.fromDate.getDate()).slice(-2);
                      let toDateMonth = ("0" + (this.toDate.getMonth() + 1)).slice(-2);
                      let toDateDate = ("0" + this.toDate.getDate()).slice(-2)
                      this.fromDateValue = this.fromDate.getFullYear() + '-' + fromDateMonth + '-' + fromDateDate;
                      this.endDateValue = this.toDate.getFullYear() + '-' + toDateMonth + '-' + toDateDate;
                      this.fromDateWithFormat = fromDateMonth + '/' + fromDateDate + '/' + this.fromDate.getFullYear();
                      this.toDateWithFormat = toDateMonth + '/' + toDateDate + '/' + this.toDate.getFullYear();

                    } else {
                      this.fromDateValue = null;
                      this.endDateValue = null;
                    }
                    detailsObject = { providerId: element.providerId, fromDateValue: this.fromDateValue, endDateValue: this.endDateValue, elements: element };
                    finalProviderArray.push(detailsObject);

                  }
                });
              }
            });
            let detailsResponse = this.providerPortalService.getClaimDataForPrivider2(finalProviderArray);
            if (detailsResponse && Array.isArray(detailsResponse)) {
              detailsResponse[0].subscribe((detailsElement: any) => {
                for (let i = 0; i < detailsElement.length; i++) {
                  let temp = detailsElement && detailsElement[i] && detailsElement[i] ?
                    detailsElement[i] : "";
                  let claimDetails;
                  if (temp) {
                    claimDetails = temp.memberData;
                    //console.log(claimDetails)
                  }
                  if (claimDetails && claimDetails.length > 0) {
                    claimDetails.map((element2: any) => {
                      if (element2.memberInfo && element2.memberInfo.length > 0) {
                        let claimArrayList: any[] = [];
                        const memberIdVal = element2.memberInfo[0].memberId;
                        const memberNameVal = element2.memberInfo[0].memberDetails[0].memberFirstName + '  ' + element2.memberInfo[0].memberDetails[0].memberLastName;
                        //const providerDetail = element2.memberInfo[0].memberDetails[0].claimSummaryList[0].claims;
                        element2.memberInfo[0].memberDetails[0].claimSummaryList.map((element: any) => {
                          element.claims.map((e: any) => {
                            claimArrayList.push(e);
                          })
                        });
                        const providerDetail = claimArrayList;
                        providerDetail.map((obj: any) => {
                          obj.memberId = memberIdVal;
                          obj.memberName = memberNameVal;
                          return obj;
                        });

                        let diagnosisCodes = '';
                        let billed;
                        let capitationCode;
                        let capitationDesc;
                        let claimId;
                        let claimReceivedDate;
                        let firstDateOfService;
                        let networkInd;
                        let payAmount;
                        let statusCode;
                        let statusDesc
                        providerDetail.forEach((eachProviderDetail: any) => {
                          if (eachProviderDetail.diagnosisCodes && eachProviderDetail.diagnosisCodes.length > 0) {
                            eachProviderDetail.diagnosisCodes.map((code: any) => {
                              diagnosisCodes = diagnosisCodes + ',' + code.diagnosisCode;
                            });
                          }
                          diagnosisCodes = diagnosisCodes.substring(1);
                          billed = eachProviderDetail.billed
                          capitationCode = eachProviderDetail.capitationCode,
                            capitationDesc = eachProviderDetail.capitationDesc,
                            claimId = eachProviderDetail.claimId,
                            claimReceivedDate = eachProviderDetail.claimReceivedDate,
                            firstDateOfService = eachProviderDetail.firstDateOfService,
                            networkInd = eachProviderDetail.networkInd,
                            payAmount = eachProviderDetail.payAmount,
                            statusCode = eachProviderDetail.statusCode,
                            statusDesc = eachProviderDetail.statusDesc
                          list.push({
                            provider: { 
                              name: detailsResponse[1][i].elements.name, 
                              npi: detailsResponse[1][i].elements.npi,
                              regionCode: detailsResponse[1][i].elements.regionCode || '',
                              providerId: detailsResponse[1][i].elements.providerId || '',
                              address: detailsResponse[1][i].elements.address || ''
                            },
                            details: {
                              memberId: eachProviderDetail.memberId, memberName: eachProviderDetail.memberName, billed: billed, capitationCode: capitationCode, capitationDesc: capitationDesc,
                              claimId: claimId, claimReceivedDate: claimReceivedDate, firstDateOfService: firstDateOfService,
                              networkInd: networkInd, payAmount: payAmount, statusCode: statusCode, statusDesc: statusDesc,
                              claimSubTypeCd: eachProviderDetail.claimSubTypeCd
                            }, diagnosisCodes: diagnosisCodes
                          });
                          
                          copyOfList.push({
                            provider: { 
                              name: detailsResponse[1][i].elements.name, 
                              npi: detailsResponse[1][i].elements.npi,
                              regionCode: detailsResponse[1][i].elements.regionCode || '',
                              providerId: detailsResponse[1][i].elements.providerId || '',
                              address: detailsResponse[1][i].elements.address || ''
                            },
                            details: {
                              memberId: eachProviderDetail.memberId, memberName: eachProviderDetail.memberName, billed: billed, capitationCode: capitationCode, capitationDesc: capitationDesc,
                              claimId: claimId, claimReceivedDate: claimReceivedDate, firstDateOfService: firstDateOfService,
                              networkInd: networkInd, payAmount: payAmount, statusCode: statusCode, statusDesc: statusDesc,
                              claimSubTypeCd: eachProviderDetail.claimSubTypeCd
                            }, diagnosisCodes: diagnosisCodes
                          });
                        });
                      }
                    });
                    //this.loading = false;
                    //this.showClaimsResults = true;
                    this.fromDate = undefined;
                    this.toDate = undefined;
                  }
                }


                setTimeout(() => {
                  const filteredList = list.filter((item: any) => item.details.networkInd === 'I');
                  this.originalProviderClaimData = filteredList;
                  this.copyOfProviderClaimData = filteredList;
                  this.providerClaimData = filteredList;
                  this.loading = false;
                }, 500);
              });

            } else {
              this.fromDate = undefined;
              this.toDate = undefined;
            }

          }
        });
    }
    catch (e) {
      console.log(e);
    }
    this.disableClaimsBtn = true;
  }
  search(): void {
    this.noRecords = false;
    if(this.searchTerm || this.searchTerm.length == 0) {
      this.isNUmber = false;
      this.providerClaimData = this.originalProviderClaimData;
    }
    if(isNaN(this.searchTerm) || !isNaN(this.searchTerm) && this.searchTerm.length > 2){
      this.isNUmber = false;
      this.noRecords = false;
      this.providerClaimData = this.copyOfProviderClaimData.filter( (element: any) => {
        if ((element.provider.name.toUpperCase().includes(this.searchTerm.toUpperCase()) || element.provider.npi.includes(this.searchTerm) || element.details.claimId.includes(this.searchTerm))) {
            return element;
        }
      });
    }
    else if(!isNaN(this.searchTerm) && this.searchTerm.length < 3 && this.searchTerm.length != 0) {
      this.isNUmber = true;
    }
  } 
  saveStateAndNavigate(claimId: any){
    this.sendEvent();
    let path = '/providerportal/claimsummarydetail/'+claimId;
    this.router.navigateByUrl(path);

  }
  sendEvent(){

    let temp = [];
    let data = {
      "stateData":
      {
        savedoriginalProviderClaimData: this.originalProviderClaimData,
        savedcopyOfProviderClaimData: this.copyOfProviderClaimData,
        savedproviderClaimData: this.providerClaimData,
      },
      "filters": {
        fromDatetoSave: this.fromDateWithFormat,
        toDatetoSave: this.toDateWithFormat,
        showClaimsResultstosave: this.showClaimsResults,
        showClaimsResultsForLast30DaystoSave: this.showClaimsResultsForLast30Days,
        endMinDatetoSave: this.endMinDate,
        endMaxDatetosave: this.endMaxDate,
        isNUmbertoSave: this.isNUmber,
        durtionRadioBtntosave: this.durtionRadioBtn,
        dateRangetoSave: this.dateRange,
        showDateSelectiontosave: this.showDateSelection,
        searchTermtoSave: this.searchTerm,

      }
    };
    temp.push({ data: data });
    //console.log(temp);
    this.claimnavigationService.receiveState(temp);
  }

  // Dispute related methods
  onClaimSelection(provider: any) {
    // Toggle selection: if already selected, deselect; otherwise select this one
    if (this.selectedClaimId === provider.details.claimId) {
      // Deselect if clicking the same checkbox
      this.selectedClaimId = '';
      this.selectedClaimData = null;
    } else {
      // Select this claim (automatically deselects any previously selected)
      this.selectedClaimId = provider.details.claimId;
      //debugger
      this.selectedClaimData = provider;
    }
    //console.log('Selected claim for dispute:', this.selectedClaimId ? provider : 'None');
  }

  openDisputeModal() {
    if (this.selectedClaimId && this.selectedClaimData) {
      //console.log('Opening dispute modal for claim:', this.selectedClaimId);
      
      const dialogRef = this.disputeDialogRef = this.dialog.open(DisputeDialogComponent, {
        width: '800px',
        maxWidth: '90vw',
        minHeight: '650px',
        data: {
          claimId: this.selectedClaimId,
          claimData: this.selectedClaimData
        },
        disableClose: false
      });

      dialogRef.afterClosed().subscribe(result => {
        this.disputeDialogRef = null;
        if (result) {
          //console.log('Dispute submitted:', result);
          //console.log('contractCode:', result.contractCode, 'facetsMemberKey:', result.facetsMemberKey, 'dcn:', result.dcn);
          alert(`Dispute submitted successfully for Claim: ${result.claimId}`);
          
          // Reset selection
          this.selectedClaimId = '';
          this.selectedClaimData = null;
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.disputeDialogRef) {
      this.disputeDialogRef.close();
      this.disputeDialogRef = null;
    }
    if (this.state) {
      this.state.unsubscribe();
    }
  }
}
